/**
 * Catalog 模块接口
 * 标签/人群目录相关
 */

import { get } from '../request';
import type {
  CatalogData,
  CatalogTabsData,
  GetCatalogParams,
  GetCatalogTabsParams,
} from '../../type/catalog-type';

/**
 * 获取分类 Tab 统计数据
 * GET /catalog/tabs
 */
export const getCatalogTabs = (params?: GetCatalogTabsParams) => {
  return get<CatalogTabsData, GetCatalogTabsParams | undefined>('/catalog/tabs', params);
};

/**
 * 获取标签/人群目录数据
 * GET /catalog
 */
export const getCatalog = (params?: GetCatalogParams) => {
  return get<CatalogData, GetCatalogParams | undefined>('/catalog', params);
};
